<template>
  <div class="my-confirm-plaugin-box" v-show="dialogVisible" @click.stop="close()">
    <div class="confirm-plaugin-box" @click.stop="">
      <div class="confirm-title">
        <div>{{msg.title}}</div>
        <div @click="close()"><img src="@/assets/img/confirmPlaugin/close.png" alt=""></div>
      </div>
      <div class="comfirm-content">
        <div class="tc-20"></div>
        <div class="img-box">
          <img v-lazy="url" alt="">
        </div>
        <div class="tc-40"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BigImage1',
  props: {

  },
  data () {
    return {
      url: '',
      msg: {
        title: '图片'
      },
      dialogVisible: true,
      callBack: function () {

      }
    }
  },
  methods: {
    close (bol) {
      this.dialogVisible = false
      if (bol) {
        this.callBack()
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  mounted () {},
  destroyed () {
    if (this.dialogVisible) {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
  .my-confirm-plaugin-box{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
    .confirm-plaugin-box{
      // width: 600px;
      max-height: 80%;
      max-width: 80%;
      margin: 5% auto 0;
      height: auto;
      background-color: #ffffff;
      border-radius: 4px;
      border:1px solid rgba(228, 231, 237, 1);
      box-shadow:0 3px 10px 0 rgba(0, 0, 0, 0.08);
      .confirm-title{
        font-size: 18px;
        border-bottom: 1px solid #E4E7ED;
        height: 60px;
        line-height: 60px;
        position: relative;
        >div{
          position: absolute;
          &:nth-child(1){
            left: 0;
            text-indent: 15px;
            top: 0;
          }
          &:nth-child(2){
            right: 0;
            top: 0;
            padding: 0 15px;
            cursor: pointer;
          }
        }
      }
      .comfirm-content{
        max-width: 80%;
        // max-height: calc(40% - 60px);
        min-height: 400px;
        margin: 0 auto;
        text-align: center;
        padding: 0px 0 0px 0;
        overflow: hidden;
        .img-box{
          margin: 0 auto;
          // height: 100%;
          max-width: 100%;
          max-height: 400px;
          overflow: hidden;
          >img{
            overflow: hidden;
            margin: 0 auto;
            // height: 100%;
            max-width: 100%;
            max-height: 400px;
          }
        }
      }
    }
  }
</style>
